require('font-awesome/css/font-awesome.css');
require('./_loadingOverlay.css');
import React, {Component } from 'react';

class LoadingOverlay extends Component {
  render() {
    if (!this.props) {
      return null;
    }else{
      return (
        <div className={`bo-overlay ${(this.props.loading) ? 'show' : ''}`}>
          <div className="loading">
            <svg className="circular" viewBox="25 25 50 50">
                <circle className="path" cx="50" cy="50" r="23" fill="none" strokeWidth="2" strokeMiterlimit="10"></circle>
            </svg>
          </div>
          <h3>{this.props.message}</h3>
        </div>
      );
    }
  }
}

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./components/LoadingOverlay/index.js